/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SuccessCreateConversationResponse } from '../models/SuccessCreateConversationResponse';
import type { SuccessPageNotificationMessageResponse } from '../models/SuccessPageNotificationMessageResponse';
import type { UpdateNotificationMessageRequest } from '../models/UpdateNotificationMessageRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class NotificationMessageControllerService {

    /**
     * Creates a new conversation from a notification message.
     * @param id
     * @returns SuccessCreateConversationResponse Conversation created successfully
     * @throws ApiError
     */
    public static createConversationFromNotification(
        id: string,
    ): CancelablePromise<SuccessCreateConversationResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/notification-messages/{id}/conversation',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `The client is not authorized to perform the action. The \`code\`, \`message\`, and \`data\` fields may provide more information about the reason of the error.`,
                404: `The requested entity was not found, or the client has no permission to access the entity.`,
                500: `An unexpected error has occurred.`,
            },
        });
    }

    /**
     * Updates a notification message. Right now the only thing that can be updated is the read status.
     * @param id
     * @param requestBody
     * @returns string OK
     * @throws ApiError
     */
    public static update(
        id: string,
        requestBody: UpdateNotificationMessageRequest,
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/v1/notification-messages/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            responseHeader: 'X-NineamHealth-TraceId',
            errors: {
                400: `Bad Request`,
                401: `The client is not authorized to perform the action. The \`code\`, \`message\`, and \`data\` fields may provide more information about the reason of the error.`,
                404: `The requested entity was not found, or the client has no permission to access the entity.`,
                500: `An unexpected error has occurred.`,
            },
        });
    }

    /**
     * Returns unread notification messages for the authenticated user.
     * @param page Zero-based page index (0..N)
     * @param size The size of the page to be returned
     * @param sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @returns SuccessPageNotificationMessageResponse OK
     * @throws ApiError
     */
    public static getUnread(
        page?: number,
        size: number = 20,
        sort?: Array<string>,
    ): CancelablePromise<SuccessPageNotificationMessageResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/notification-messages/unread',
            query: {
                'page': page,
                'size': size,
                'sort': sort,
            },
            errors: {
                400: `Bad Request`,
                401: `The client is not authorized to perform the action. The \`code\`, \`message\`, and \`data\` fields may provide more information about the reason of the error.`,
                404: `The requested entity was not found, or the client has no permission to access the entity.`,
                500: `An unexpected error has occurred.`,
            },
        });
    }

    /**
     * Returns read notification messages for the authenticated user.
     * @param page Zero-based page index (0..N)
     * @param size The size of the page to be returned
     * @param sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @returns SuccessPageNotificationMessageResponse OK
     * @throws ApiError
     */
    public static getRead(
        page?: number,
        size: number = 20,
        sort?: Array<string>,
    ): CancelablePromise<SuccessPageNotificationMessageResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/notification-messages/read',
            query: {
                'page': page,
                'size': size,
                'sort': sort,
            },
            errors: {
                400: `Bad Request`,
                401: `The client is not authorized to perform the action. The \`code\`, \`message\`, and \`data\` fields may provide more information about the reason of the error.`,
                404: `The requested entity was not found, or the client has no permission to access the entity.`,
                500: `An unexpected error has occurred.`,
            },
        });
    }

}
